export enum ConversationState {
  AI_SPEAKING,
  USER_SPEAKING,
  IDLE,
  ENDED
}
